exports.sendMail = async (params) => {
  const AWS = require("aws-sdk");

  AWS.config.update({
    accessKeyId: process.env.GATSBY_AWS_ACCESS_KEY,
    secretAccessKey: process.env.GATSBY_AWS_SECRET_KEY,
    region: process.env.GATSBY_AWS_REGION,
  });

  const ses = new AWS.SES({ apiVersion: "2010-12-01" });
  const emailParams = {
    Destination: {
      ToAddresses: [params.email], // Email address/addresses that you want to send your email
    },
    //   ConfigurationSetName: <<ConfigurationSetName>>,
    Message: {
      Body: {
        Html: {
          // HTML Format of the email
          Charset: "UTF-8",
          Data: `<html>
                  <body>
                    ${
                      params.fromEmail ? `Email: ${params.fromEmail}<br />` : ""
                    }
                    ${
                      params.firstname
                        ? `Firstname: ${params.firstname}<br />`
                        : ""
                    }
                    ${
                      params.lastname
                        ? `Lastname: ${params.lastname}<br />`
                        : ""
                    }
                    ${params.company ? `Company: ${params.company}<br />` : ""}
                    ${params.message ? `Message: ${params.message}<br />` : ""}
                  </body>
                </html>`,
        },
        Text: {
          Charset: "UTF-8",
          Data: "",
        },
      },
      Subject: {
        Charset: "UTF-8",
        Data: params.subject,
      },
    },
    Source: "noreply@hevelop.com",
  };

  return ses
    .sendEmail(emailParams)
    .promise()
    .then((data) => {
      console.log("email submitted to SES", data);
      return {
        statusCode: 200,
        body: `Message sent`,
      };
    })
    .catch((error) => {
      console.log(error);
      return {
        statusCode: 500,
        body: `Message unsuccesfully sent`,
      };
    });
};
